import { type TranslationSchema } from '~/locales/resources'

export const segmentDisplayTypes = [
  'fiveSegs',
  'nineSegs',
  'both',
  'summary',
] as const
export type SegmentDisplayType = (typeof segmentDisplayTypes)[number]

export const segmentDisplayTypeLabelI18nKeyMap = {
  fiveSegs: 'five_segs',
  nineSegs: 'nine_segs',
  both: 'both',
  summary: 'summary',
} as const satisfies Record<SegmentDisplayType, keyof TranslationSchema>
